import React, { useState, useEffect } from 'react'

const DataCenter = () => {
    const [activeService, setActiveService] = useState('datacenter-design');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">MISSION-CRITICAL INFRASTRUCTURE</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    Data Center <span className="breadcrumb-highlight">Solutions</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Data Center Overview Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Enterprise Data Center </span> Infrastructure & Management
                                </h2>
                                <p className="ai-driven-description">
                                    Build and maintain world-class data center infrastructure with CLOUD MIND X's comprehensive solutions. Our experts deliver end-to-end services spanning design, implementation, migration, and management of modern data centers. We optimize performance, ensure high availability, reduce energy consumption, and implement best practices for mission-critical operations. From colocation to hyperscale facilities, we power the digital backbone of enterprises worldwide.
                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO DATA CENTER EXPERT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80"
                                    alt="Data Center Solutions"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR DATA CENTER EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With certified data center professionals and proven infrastructure expertise,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> delivers reliable, scalable, and efficient data center solutions<br />
                                    that support business-critical operations and drive digital transformation.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="datacenter-design">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Data Center Design & Build</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="datacenter-migration">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Data Center Migration</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="infrastructure-management">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Infrastructure Management</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="colocation-services">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Colocation Services</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="disaster-recovery">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Disaster Recovery & BCP</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="datacenter-optimization">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Data Center Optimization</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* Data Center Design */}
                                <div className="service-detail active" id="datacenter-design">
                                    <h3 className="service-detail-title">Data Center Design & Build</h3>
                                    <p className="service-detail-description">
                                        Design and construct state-of-the-art data centers tailored to your requirements. Our architects consider power distribution, cooling systems, network topology, security, and scalability. We adhere to Tier standards (I-IV), implement hot/cold aisle containment, redundant power, and modular designs that support future growth while optimizing capital and operational expenditures.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Design Consultation</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Data Center Migration */}
                                <div className="service-detail" id="datacenter-migration">
                                    <h3 className="service-detail-title">Data Center Migration</h3>
                                    <p className="service-detail-description">
                                        Execute seamless data center migrations with minimal downtime and zero data loss. Our migration specialists plan and coordinate physical and virtual server moves, network reconfiguration, application migration, and cutover activities. We conduct thorough testing, implement rollback procedures, and ensure business continuity throughout the migration process.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Migration Planning</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Infrastructure Management */}
                                <div className="service-detail" id="infrastructure-management">
                                    <h3 className="service-detail-title">Infrastructure Management</h3>
                                    <p className="service-detail-description">
                                        Maintain optimal data center operations with 24/7 infrastructure management services. We monitor and manage servers, storage, networks, power, cooling, and environmental systems. Our proactive approach includes preventive maintenance, capacity planning, performance optimization, and rapid incident response to ensure maximum uptime and reliability.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Management Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Colocation Services */}
                                <div className="service-detail" id="colocation-services">
                                    <h3 className="service-detail-title">Colocation Services</h3>
                                    <p className="service-detail-description">
                                        Leverage enterprise-grade colocation facilities with carrier-neutral connectivity, redundant power, advanced cooling, and physical security. Our colocation services provide flexible rack space, cage options, and private suites with SLA-backed uptime guarantees. Benefit from reduced capital expenses, improved reliability, and access to multiple network carriers and cloud providers.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Colocation Quote</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Disaster Recovery */}
                                <div className="service-detail" id="disaster-recovery">
                                    <h3 className="service-detail-title">Disaster Recovery & Business Continuity</h3>
                                    <p className="service-detail-description">
                                        Ensure business resilience with comprehensive disaster recovery and business continuity solutions. We design and implement DR strategies including backup and replication, failover mechanisms, and recovery procedures. Our solutions achieve aggressive RPO/RTO targets, support regular DR testing, and provide confidence in your ability to recover from any disruption.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request DR Assessment</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Data Center Optimization */}
                                <div className="service-detail" id="datacenter-optimization">
                                    <h3 className="service-detail-title">Data Center Optimization</h3>
                                    <p className="service-detail-description">
                                        Maximize efficiency and reduce costs through comprehensive data center optimization. We analyze power consumption, cooling efficiency, server utilization, and infrastructure capacity. Our optimization strategies include virtualization, consolidation, energy-efficient equipment upgrades, airflow management, and intelligent power distribution that reduce PUE and operational expenses.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Optimization Audit</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Data Center Technologies Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">INFRASTRUCTURE TECHNOLOGIES</span>
                                <h2 className="section-title-dark">Data Center Technologies & Infrastructure</h2>
                                <p className="section-description-dark">
                                    CLOUD MIND X implements cutting-edge data center technologies and infrastructure solutions. Our expertise covers <strong>compute, storage, networking, power, and cooling systems</strong> serving healthcare, financial services, telecommunications, government, education, and enterprise sectors with mission-critical infrastructure requirements.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* Server Infrastructure */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="12" width="32" height="6" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="8" y="21" width="32" height="6" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="8" y="30" width="32" height="6" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="13" cy="15" r="1.5" fill="#4187f7" />
                                        <circle cx="13" cy="24" r="1.5" fill="#4187f7" />
                                        <circle cx="13" cy="33" r="1.5" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Server Infrastructure</h4>
                                <p className="capability-description">
                                    Deploy high-performance server infrastructure including rack servers, blade servers, and hyper-converged infrastructure (HCI). We implement server virtualization with VMware, Hyper-V, and KVM, optimizing resource utilization and workload management. Our server solutions deliver exceptional compute power, scalability, and reliability for demanding enterprise applications.
                                </p>
                            </div>
                        </div>

                        {/* Storage Solutions */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse cx="24" cy="16" rx="14" ry="6" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M10 16V24C10 26.2 14 30 24 30C34 30 38 26.2 38 24V16" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M10 24V32C10 34.2 14 38 24 38C34 38 38 34.2 38 32V24" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 20H30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Storage Solutions</h4>
                                <p className="capability-description">
                                    Implement enterprise storage solutions including SAN, NAS, object storage, and software-defined storage (SDS). We deploy tiered storage architectures with SSD, NVMe, and traditional disk arrays optimized for performance and cost. Our storage designs ensure data protection, high availability, and seamless scalability for growing data requirements.
                                </p>
                            </div>
                        </div>

                        {/* Network Infrastructure */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="4" fill="#4187f7" />
                                        <circle cx="12" cy="12" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="36" cy="12" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="12" cy="36" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="36" cy="36" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M15 14L21 22M33 14L27 22M15 34L21 26M33 34L27 26" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Network Infrastructure</h4>
                                <p className="capability-description">
                                    Build robust network infrastructures with high-speed switches, routers, load balancers, and SDN technologies. We design redundant network topologies with 10/40/100GbE connectivity, VLAN segmentation, and multi-path routing. Our networking solutions ensure low-latency, high-throughput connectivity supporting mission-critical applications and services.
                                </p>
                            </div>
                        </div>

                        {/* Power Systems */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M28 10L18 26H24L20 38L30 22H24L28 10Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <circle cx="24" cy="24" r="16" stroke="#4187f7" strokeWidth="2" opacity="0.2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Power & UPS Systems</h4>
                                <p className="capability-description">
                                    Ensure uninterrupted power with redundant UPS systems, backup generators, and intelligent PDUs. We implement N+1 or 2N power configurations, automatic transfer switches, and battery management systems. Our power infrastructure provides clean, conditioned power with seamless failover capabilities, protecting equipment and maintaining operations during outages.
                                </p>
                            </div>
                        </div>

                        {/* Cooling Systems */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="10" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 14V34M14 24H34" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M17 17L31 31M31 17L17 31" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="14" stroke="#4187f7" strokeWidth="2" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Cooling & HVAC</h4>
                                <p className="capability-description">
                                    Implement efficient cooling systems including CRAC units, in-row cooling, liquid cooling, and free cooling technologies. We design hot/cold aisle containment, optimize airflow management, and deploy environmental monitoring. Our cooling solutions maintain optimal temperature and humidity while minimizing energy consumption and reducing PUE ratios.
                                </p>
                            </div>
                        </div>

                        {/* Physical Security */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="12" y="18" width="24" height="20" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 18V14C18 11 20 8 24 8C28 8 30 11 30 14V18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="24" cy="28" r="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 28V32" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Physical Security</h4>
                                <p className="capability-description">
                                    Protect data center facilities with multi-layered physical security including biometric access control, video surveillance, intrusion detection, and security personnel. We implement mantrap entries, visitor management, audit trails, and 24/7 monitoring. Our security measures ensure only authorized personnel access critical infrastructure while maintaining compliance.
                                </p>
                            </div>
                        </div>

                        {/* Monitoring & Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="12" width="32" height="20" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 18H40" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="13" cy="15" r="1" fill="#4187f7" />
                                        <circle cx="17" cy="15" r="1" fill="#4187f7" />
                                        <path d="M14 24L20 28L28 20" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">DCIM & Monitoring</h4>
                                <p className="capability-description">
                                    Deploy comprehensive Data Center Infrastructure Management (DCIM) solutions for real-time monitoring and analytics. We implement monitoring systems tracking power consumption, temperature, humidity, network performance, and asset utilization. Our DCIM platforms provide insights for capacity planning, energy optimization, and predictive maintenance.
                                </p>
                            </div>
                        </div>

                        {/* Automation & Orchestration */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="14" cy="14" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="34" cy="14" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="14" cy="34" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="34" cy="34" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 14H30M14 18V30M34 18V30M18 34H30" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="20" y="20" width="8" height="8" rx="1" fill="#4187f7" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Automation & Orchestration</h4>
                                <p className="capability-description">
                                    Streamline data center operations with automation and orchestration platforms. We implement infrastructure-as-code, automated provisioning, configuration management, and workflow automation. Our solutions reduce manual tasks, minimize errors, accelerate deployment times, and enable self-service capabilities while maintaining governance and control.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DataCenter
